import type { AlpineComponent } from 'alpinejs'
import type { UJSResponse } from './modal_form'

export type ChangeItemCountEvent = CustomEvent<{ items: number; reload: boolean }>

export const itemsPerPage = ({ formId }: { formId: string }): AlpineComponent<{ updateItemsPerPage: () => void }> => ({
  updateItemsPerPage() {
    const items = (this.$el as HTMLSelectElement).value

    // Send a custom event to trigger reloading search results
    document
      .getElementById(formId)
      ?.dispatchEvent(new CustomEvent('change-item-count', { detail: { items, reload: true } }))
  },
})

// Updates the contents of closest `<output>` by default, or any element if `targetId` is provided
export const PagyRemoteLink = (
  targetId?: string
): AlpineComponent<{
  'data-remote': 'true'
  '@ajax:success': (event: UJSResponse) => void
}> => ({
  'data-remote': 'true',
  '@ajax:success'(e) {
    const container = targetId ? document.getElementById(targetId) : this.$root.closest('output')

    if (!container) {
      console.error('Container not found', this.$root)
      return
    }

    container.innerHTML = e.detail[2].responseText
  },
})
